/* eslint-disable */
import { cn } from '../../lib/utils';

interface Account {
  id: number | string;
  email: string;
}

interface AccountSwitcherProps {
  accounts: Account[];
  selectedAccounts: string[];
  onToggle: (email: string) => void;
  onClear: () => void;
  isMobile?: boolean;
}

export function AccountSwitcher({
  accounts,
  selectedAccounts,
  onToggle,
  onClear,
  isMobile = false,
}: AccountSwitcherProps) {
  if (accounts.length === 0) return null;

  if (isMobile) {
    return (
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className="text-[10px] font-semibold text-muted-foreground">Accounts</span>
          {selectedAccounts.length > 0 && (
            <button
              onClick={onClear}
              className="text-[10px] text-primary font-medium hover:underline"
            >
              Clear all
            </button>
          )}
        </div>
        <div className="flex items-center gap-1.5 overflow-x-auto pb-1 no-scrollbar">
          {accounts.map((acc) => {
            const isSelected = selectedAccounts.includes(acc.email);
            return (
              <button
                key={acc.id}
                onClick={() => onToggle(acc.email)}
                className={cn(
                  'flex items-center gap-1.5 px-2 py-1 rounded-full border text-[10px] font-medium transition-all shrink-0',
                  isSelected
                    ? 'bg-primary text-primary-foreground border-primary '
                    : 'bg-card border-muted/50 text-muted-foreground hover:border-primary/30'
                )}
              >
                <div
                  className={cn(
                    'h-1.5 w-1.5 rounded-full',
                    isSelected ? 'bg-primary-foreground' : 'bg-primary/40'
                  )}
                />
                {acc.email.split('@')[0]}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <h4 className="text-xs font-medium text-muted-foreground flex items-center justify-between">
        Accounts
        {selectedAccounts.length > 0 && (
          <button onClick={onClear} className="text-[10px] lowercase text-primary hover:underline">
            clear
          </button>
        )}
      </h4>
      <div className="space-y-1.5 max-h-40 overflow-y-auto pr-1">
        {accounts.map((acc) => (
          <label key={acc.id} className="flex items-center gap-2 cursor-pointer group">
            <input
              type="checkbox"
              checked={selectedAccounts.includes(acc.email)}
              onChange={() => onToggle(acc.email)}
              className="rounded border-border text-primary focus:ring-primary h-3.5 w-3.5"
            />
            <span
              className={cn(
                'text-xs font-medium transition-colors truncate flex-1',
                selectedAccounts.includes(acc.email)
                  ? 'text-foreground'
                  : 'text-muted-foreground group-hover:text-foreground'
              )}
            >
              {acc.email}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
